// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="july-6-2021">July 6, 2021</h3>
      <p>Time zone data has now been added to API repsonse</p>
      <ul>
      <li><code>time_zone</code> represents the corresponding IANA format time zone for the facility returned</li>
      <li>Example value for Orlando VA Medical Center: &quot;America/New_York&quot;</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/226">View the code change(s)</a></p>
      <hr />
      <h3 id="april-15-2021">April 15, 2021</h3>
      <p>We added a new meta section to the /nearby endpoint with a new <code>band_version</code> field.</p>
      <ul>
      <li><code>band_version</code> represents the data set used in the distance calculation</li>
      <li><code>band_version</code> value may be up to 6 weeks behind the current date</li>
      <li>Example value: &quot;FEB2021&quot; with a return date in March, 2021</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/209">View the code change(s)</a></p>
      <hr />
      <h3 id="april-1-2021">April 1, 2021</h3>
      <p>Service-specific details are now available for the Covid19Vaccine service where applicable.</p>
      <ul>
      <li><code>detailed_services</code> was added to the facilities API response for all facilities</li>
      <li>Facilities offering the Covid19Vaccine health service provide detailed service info in this field</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/198">View the code change(s)</a></p>
      <hr />
      <h3 id="january-29-2021">January 29, 2021</h3>
      <p>Corrected <code>operationalHoursSpecialInstructions</code> to <code>operational_hours_special_instructions</code></p>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/195">View the code change(s)</a></p>
      <hr />
      <h3 id="january-20-2021">January 20, 2021</h3>
      <p>You can now return additional notes related to operational hours for a facility.</p>
      <ul>
      <li>New field <code>operationalhoursspecialinstructions</code> included in the Facilities API response</li>
      <li>This field is only applicable to health facilities (vha) and vet centers (vc)</li>
      <li>Example value: &quot;Administrative hours are Monday-Friday 8:00 a.m. to 4:30 p.m.&quot;</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/172">View the code change(s)</a></p>
      <hr />
      <h3 id="january-11-2021">January 11, 2021</h3>
      <p>You can now see if a facility offers Covid-19 vaccines.</p>
      <ul>
      <li><code>Covid19Vaccine</code> will return as a new service type for facilities, where available</li>
      <li>The <code>Covid19Vaccine</code> service does not have satisfaction scores or wait times</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/184">View the code change(s)</a></p>
      <hr />
      <h3 id="december-2-2020">December 2, 2020</h3>
      <p>Location queries now support filtering by mobile status.</p>
      <ul>
      <li>Added <code>mobile</code> filter parameter to facilities endpoint</li>
      <li>Options for <code>mobile</code> are <code>true</code> or <code>false</code></li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/169">View the code change(s)</a></p>
      <hr />
      <h3 id="november-16-2020">November 16, 2020</h3>
      <p>You can now search for facilities by Veterans Integrated Service Network (VISN).</p>
      <ul>
      <li>Added <code>visn</code> search parameter to facilities endpoint</li>
      <li>Additional search parameters (such as <code>lat</code> and <code>long</code>) are not supported with this search type</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/165">View the code change(s)</a></p>
      <hr />
      <h3 id="august-24-2020">August 24, 2020</h3>
      <p>A new <code>/ids</code> endpoint was added to the Facilities API which retrieves all facility IDs and supports filtering by facility type.</p>
      <hr />
      <h3 id="april-20-2020">April 20, 2020</h3>
      <p>You can now see if Health facilities offer Podiatry or Nutrition services.</p>
      <ul>
      <li>
      <p>Added <code>Podiatry</code> and <code>Nutrition</code> to the array of available services for a facility, where available. At this time, we do not have satisfaction scores and are not exposing wait times for podiatry or nutrition services.</p>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/38">View the code change(s)</a></p>
      </li>
      </ul>
      <p>You can now see Health facilities' operating status and any important textual notes about that facility.</p>
      <ul>
      <li>Added <code>operating_status</code> and <code>additional_info</code> flags to the API response for Health facilities (other facility types will return null for these fields). Options for operating_status are <code>normal, notice, limited, closed</code>; options for <code>additional_info</code> is a text string showing details of facility notices for visitors, such as messages about parking lot closures or floor visitation information.</li>
      <li><code>active_status</code> is deprecated and replaced with <code>operating_status</code>. It will be removed in version 1.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/lighthouse-facilities/pull/58">View code change(s)</a></p>
      <p>Note: the Facilities API codebase was refactored and separated from the vets-api repository.</p>
      <hr />
      <h3 id="december-6-2019">December 6, 2019</h3>
      <p>The Veterans Integrated Service Network (VISN) identifier for each health facility is now available.</p>
      <ul>
      <li><code>visn</code> has been added to all <code>/facilities</code> endpoints. <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3609">View code change(s)</a></li>
      <li>For non-health facilities, this will return as <code>null</code>.</li>
      </ul>
      <hr />
      <h3 id="november-8-2019">November 8, 2019</h3>
      <p>The <code>/nearby</code> endpoint received major changes.</p>
      <ul>
      <li>Previously, the server retrieved an isochrone (a line connecting points of the same time) for a provided location and looked for facilities that fell within that polygon. Now the opposite is true: facilities have isochrones that are compared against the provided location. Users should see increased performance from this endpoint as a result.</li>
      <li>Data about drive times now comes directly from the Veterans Health Administration (VHA). Responses may vary slightly from the previous implementation because of this switch.</li>
      <li>The response schema has also changed. Instead of returning facility data from <code>/nearby</code>, the endpoint now provides <code>min_time</code> and <code>max_time</code> attributes for the matching polygons and links to endpoints that can be queried to retrieve full information about the associated facility. This schema change allows us to keep <code>/nearby</code> within v0 of the Facilities API instead of incrementing to v1. See the schema changes by <a href="https://developer.va.gov/explore/facilities/docs/facilities">visiting the documentation</a>.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3512">View code change(s)</a></p>
      <hr />
      <h3 id="october-23-2019">October 23, 2019</h3>
      <p>When including latitude and longitude parameters in a request to  <code>/facilities</code> the results are now sorted in ascending order by distance.</p>
      <ul>
      <li>Previously the facilities in the response were sorted by type first and then distance. Now the closest facilities to the requested location will be returned first regardless of type. <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3461">View code change(s)</a></li>
      </ul>
      <hr />
      <h3 id="september-30-2019">September 30, 2019</h3>
      <p>You can now see if Health facilities are mobile or temporarily deactivated.</p>
      <ul>
      <li>Added <code>mobile</code> and <code>active_status</code> flags to the API response for Health facilities (other facility types will return <code>null</code> for these fields). Options for <code>mobile</code> are <code>true</code> or <code>false</code>; options for <code>active_status</code> are <code>A</code> for Active or <code>T</code> for Temporarily deactivated. <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3339/commits">View code change(s)</a>
      <ul>
      <li>Mobile facilities are subject to frequent address changes. To get the exact current location, please call the number listed.</li>
      </ul>
      </li>
      </ul>
      <hr />
      <h3 id="september-20-2019">September 20, 2019</h3>
      <p>You can now query facilities in <code>/nearby</code> using latitude and longitude</p>
      <ul>
      <li>As an alternative option to <code>address</code>, this adds the ability to make a request to <code>/va_facilities/v1/nearby</code> using <code>lat</code> and <code>lng</code> as input parameters. <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3273/commits">View code change(s)</a></li>
      </ul>
      <hr />
      <h3 id="june-17-2019">June 17, 2019</h3>
      <p>Get nearby facilities for an address <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3084">#3084</a></p>
      <ul>
      <li><code>/nearby</code>, the first available endpoint for v1 of Facilities API, returns all facilities within a provided drive time for an address</li>
      <li>v1 changes
      <ul>
      <li>Changed <code>long</code> to <code>lng</code> to accommodate typed languages <a href="https://github.com/department-of-veterans-affairs/vets-api-clients/issues/15">#15</a></li>
      <li>Wait times are now nested in the Health services array</li>
      </ul>
      </li>
      </ul>
      <hr />
      <h3 id="april-26-2019">April 26, 2019</h3>
      <p>Get facilities by state <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2992">#2992</a></p>
      <ul>
      <li>Facilities endpoint now accepts <code>state</code> as a parameter. This returns all facilities in a particular state/territory.</li>
      </ul>
      <hr />
      <h3 id="april-25-2019">April 25, 2019</h3>
      <p>Get facilities by zip <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2987">#2987</a></p>
      <ul>
      <li>Facilities endpoint now accepts <code>zip</code> as a parameter. This returns all facilities in a particular zip code.</li>
      </ul>
      <hr />
      <h3 id="april-18-2019">April 18, 2019</h3>
      <p>Fix error when returning CSV <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2974">#2974</a></p>
      <ul>
      <li>The <code>/facilities/all</code> endpoint no longer returns a 500 status code when a user requests <code>text/csv</code></li>
      </ul>
      <hr />
      <h3 id="february-13-2019">February 13, 2019</h3>
      <p>Standardize closed days to &quot;Closed&quot; in Facilities API <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2802">#2802</a></p>
      <ul>
      <li>Changes any casing of &quot;closed&quot; and &quot;-&quot; to &quot;Closed&quot; for a consistent convention in the Facilities API</li>
      </ul>
      <hr />
      <h3 id="january-16-2019">January 16, 2019</h3>
      <p>Fix facilities api bugs <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2735">#2735</a></p>
      <ul>
      <li>Allows users to pass both a list of IDs and a lat/long in the same request.</li>
      <li>Populate missing location data in NCA, VBA, and VC facilities, <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2735/files#diff-a0253f0a6c07463fb11a513df82f21d2">view specific change</a>.</li>
      </ul>
      <hr />
      <h3 id="december-26-2018">December 26, 2018</h3>
      <p>Remove community care providers from all facilities search <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2582">#2582</a></p>
      <ul>
      <li>Reverts back to the old functionality, removing community care providers from the all facility search</li>
      <li>Community care providers can now only be searched by passing <code>type=cc_provider</code> into the search endpoint</li>
      </ul>
      <hr />
      <h3 id="november-20-2018">November 20, 2018</h3>
      <p>Add facilities distances <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2687">#2687</a></p>
      <ul>
      <li>Adds distance to meta property of lat/long inquiries to the Facilities API and adds documentation for the meta property</li>
      <li>Facility distances from lat/long point are returned in responses</li>
      </ul>
      <hr />
      <h3 id="november-12-2018">November 12, 2018</h3>
      <p>Community care provider searches <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2405">#2405</a></p>
      <ul>
      <li>This enhances the facilities search endpoint to include community care providers in the search by default</li>
      <li>Additionally, it supports searching for just community care  providers by passing <code>type=cc_provider</code> into the search endpoint</li>
      </ul>
      <hr />
      <h3 id="august-13-2018">August 13, 2018</h3>
      <p>Launch of the VA Facilities API</p>
      <ul>
      <li>VA_Facilities API endpoint for external API consumers. Supports json/<a href="http://geojson.org/">geojson</a> results and a bulk &quot;get all&quot; endpoint in geojson and csv format.</li>
      </ul>
    </div>
  );
};

export default MarkdownComponent;
